import { FC } from "react";
import DocumentsSidebar from "./DocumentsSidebar";
import DocumentsContents from "./documents-contents/DocumentsContents";
import { DocumentsSections } from "../../../domain/enums/DocumentsSectionsEnum";

interface DocumentsPageProps {
    documentsSection: DocumentsSections;
    setDocumentsSection: (value: DocumentsSections) => void;
}

const DocumentsPage: FC<DocumentsPageProps> = (props) => {
    return (
        <div className="relative flex tmax5:flex-col gap-[70px]">
            <DocumentsSidebar
                documentsSection={props.documentsSection}
                setDocumentsSection={props.setDocumentsSection}
            />
            <DocumentsContents documentsSection={props.documentsSection} />
        </div>
    );
};

export default DocumentsPage;
